import { EventSourceHandler } from '@sellsy/sse';

export default class SamSubscriptionProcessingEventSourceHandler extends EventSourceHandler {
    constructor(){
        super()
        this.type = 'corporation.sam.subscription.processing'
    }

    handle(event){
        $('#subscribe-bar-trial').addClass('hidden');
        $('#subscribe-bar-pending').removeClass('hidden');

    }
}